// extracted by mini-css-extract-plugin
module.exports = {"guideRemind":"GiftRemind_guideRemind_1RAvj","close":"GiftRemind_close_3jp8w","btnGroup":"GiftRemind_btnGroup_2Zg27"};